import React from "react";
import {HashLink as Link} from 'react-router-hash-link';
import Panel from "../../Panel";
import Modal from "../../Modal";

const Ogen = () => (
    <Modal>
        <div>
            <Panel title={'Belangrijkste risicofactoren voor kindermishandeling'}
                   element={'h3'}
                   link={'Factoren tonen'}
                   intro={'            Algemeen wordt aangenomen dat kindermishandeling geen eenduidige oorzaak\n' +
                       '            heeft, maar vrijwel altijd het gevolg is van een combinatie en opeenstapeling van\n' +
                       '            risicofactoren (MacKenzie, Kotch, &amp; Lee, 2011; Mulder, 2014; Van Rooijen, Berg, &amp;\n' +
                       '            Bartelink, 2013). Van sommige (groepen van) risicofactoren kan echter wel gezegd\n' +
                       '            worden dat die zwaarder wegen dan andere factoren. De belangrijkste risicofactoren\n' +
                       '            voor kindermishandeling blijken de factoren te zijn die puur met de ouder(s) of\n' +
                       '            verzorger(s) te maken hebben. Deze factoren vormen bovendien een groter risico\n' +
                       '            wanneer die bij beide ouders worden gevonden, zo blijkt uit een recente meta-\n' +
                       '            analyse (Mulder, 2014). De belangrijkste risicofactoren die met goed\n' +
                       '            wetenschappelijk onderzoek zijn onderbouwd (Alink et al., 2011; Mulder, 2014; Stith\n' +
                       '            et al., 2009) worden hieronder weergegeven.'}
                   open={true}>

                <p className={'text'}>
                    Algemeen wordt aangenomen dat kindermishandeling geen eenduidige oorzaak
                    heeft, maar vrijwel altijd het gevolg is van een combinatie en opeenstapeling van
                    risicofactoren (MacKenzie, Kotch, &amp; Lee, 2011; Mulder, 2014; Van Rooijen, Berg, &amp;
                    Bartelink, 2013). Van sommige (groepen van) risicofactoren kan echter wel gezegd
                    worden dat die zwaarder wegen dan andere factoren. De belangrijkste risicofactoren
                    voor kindermishandeling blijken de factoren te zijn die puur met de ouder(s) of
                    verzorger(s) te maken hebben. Deze factoren vormen bovendien een groter risico
                    wanneer die bij beide ouders worden gevonden, zo blijkt uit een recente meta-
                    analyse (Mulder, 2014). De belangrijkste risicofactoren die met goed
                    wetenschappelijk onderzoek zijn onderbouwd (Alink et al., 2011; Mulder, 2014; Stith
                    et al., 2009) worden hieronder weergegeven.
                </p>

                <h4>De belangrijkste factoren bij de ouder(s)</h4>

                <p>Middelmatig tot grote voorspellende waarde:</p>

                <ul>
                    <li>partnergeweld;</li>
                    <li>psychische en psychiatrische problemen zoals depressie;</li>
                    <li>temperament, prikkelbaarheid, hyperreactiviteit;</li>
                    <li>ouder heeft kindermishandeling in de jeugd meegemaakt en/of was getuige van partnergeweld;</li>
                    <li>ongewenste zwangerschap.</li>
                </ul>

                <p>Lage voorspellende waarde:</p>

                <ul>
                    <li>alcoholmisbruik en drugsgebruik;</li>
                    <li>gezondheidsproblemen;</li>
                    <li>crimineel gedrag;</li>
                    <li>laag gevoel van eigenwaarde;</li>
                    <li>veel persoonlijke stress;</li>
                    <li>gering probleemoplossend vermogen of lage intelligentie.</li>
                </ul>

                <h4>De belangrijkste factoren in en om het gezin</h4>
                <p>Middelmatig tot grote voorspellende waarde:</p>
                <ul>
                    <li>geringe samenhang of cohesie in het gezin;</li>
                    <li>veel conflicten in het gezin.</li>
                </ul>
                <p>Lage voorspellende waarde:</p>
                <ul>
                    <li>lage SES (Sociaal Economische Status) of werkloosheid;</li>
                    <li>geringe sociale steun;</li>
                    <li>status als nieuwe allochtoon of vluchteling;</li>
                    <li>alleenstaande ouder;</li>
                    <li>groot gezin.</li>
                </ul>

                <h4>De belangrijkste factoren in de ouder-kind interactie</h4>
                <p>Middelmatig tot grote voorspellende waarde:</p>
                <ul>
                    <li>ouder ziet de jeugdige als een probleem.</li>
                    <li>gebruik van fysieke straf;</li>
                    <li>geen goede gehechtheidsrelatie.</li>
                    <li>Lage voorspellende waarde:</li>
                    <li>opvoedingsstress.</li>
                </ul>

                <h4>De belangrijkste factoren bij de jeugdige</h4>
                <p>Middelmatig tot grote voorspellende waarde:</p>
                <ul>
                    <li>erg jonge leeftijd (&lt; 3 jaar).</li>
                    <li>Lage voorspellende waarde:</li>
                    <li>geringe fysieke gezondheid;</li>
                    <li>internaliserend probleemgedrag;</li>
                    <li>externaliserend probleemgedrag;</li>
                    <li>gebrekkige sociale vaardigheden.</li>
                </ul>

                <h4>Aanvullende risicofactoren voor kindermishandeling</h4>
                <p className={'text'}>
                    Voor de bovenstaande factoren is er sterk bewijs volgens meta-analyses en de NPM-
                    2010 dat die een risico vormen voor het ontstaan van kindermishandeling. Het is
                    echter waarschijnlijk dat ook andere risicofactoren een rol spelen bij het ontstaan van
                    kindermishandeling, maar dat daar nog onvoldoende onderzoek naar is gedaan. In
                    een meta-analyse komen deze risicofactoren dan niet of als minder sterk naar voren.
                </p>

                <h4>Andere factoren die waarschijnlijk ook een risico vormen voor het ontstaan van kindermishandeling,
                    zijn:</h4>

                <h5>Bij de ouder(s):</h5>
                <ul>
                    <li>leeftijd (tiener- of jonge ouders)</li>
                    <li>één-ouderschap</li>
                    <li>chronische ziekte of kwetsbare gezondheid</li>
                    <li>suïcide(pogingen)</li>
                    <li>crimineel verleden</li>
                    <li>verstoorde interactie tussen ouders</li>
                    <li>(vecht)scheiding, nieuwe relatie/huwelijk</li>
                    <li>beperkte of inadequate opvoedvaardigheden</li>
                </ul>

                <h5>In en om het gezin:</h5>
                <ul>
                    <li>gezinsgrootte en aantal kinderen (grote gezinnen)</li>
                    <li>eerdere ondertoezichtstelling (OTS) en bemoeienis Veilig Thuis (1)/Raad voor de
                        Kinderbescherming
                    </li>
                    <li>criminaliteit in de buurt</li>
                    <li>weinig sociale cohesie in buurt</li>
                    <li>gemengde cultuur in het gezin</li>
                    <li>slechte relatie met (stief)broertjes/zusjes</li>
                    <li>weinig of geen (functionerend) sociale netwerk</li>
                    <li>geen sociale controle vanuit netwerk en buurt</li>
                    <li>stress en instabiliteit in het gezin</li>
                    <li>ouder in hechtenis</li>
                    <li>inwonende familieleden</li>
                    <li>afwezigheid van volwassenen en geen toezicht</li>
                </ul>

                <h5>In de ouder-kind interactie:</h5>
                <ul>
                    <li>negatieve verbale reacties van ouder naar jeugdige</li>
                    <li>irritatie van de ouder bij huilen jeugdige</li>
                    <li>fysiek corrigeren of straffen bij ongewenst gedrag (pedagogische tik)</li>
                    <li>gebrek aan betrokkenheid</li>
                    <li>gebrek aan warmte</li>
                    <li>problematische gehechtheid</li>
                    <li>Bij de jeugdige:</li>
                    <li>beneden gemiddelde intelligentie</li>
                    <li>geboortecomplicaties, laag geboortegewicht, lage APGAR-score, prematuur, afwijking bij
                        geboorte
                    </li>
                    <li>chronische ziekte, gezondheidsproblemen</li>
                    <li>externaliserende gedragsproblemen</li>
                    <li>internaliserende gedragsproblemen</li>
                    <li>psychische problemen / psychiatrische aandoening</li>
                    <li>achterblijvende taalontwikkeling of –vermogen.</li>
                </ul>

                <h5>Specifieke risicofactoren voor verwaarlozing</h5>
                <p className={'text'}>
                    Verwaarlozing blijkt volgens de genoemde meta-analyses statistisch moeilijker te
                    voorspellen op basis van risicofactoren dan wanneer naar kindermishandeling in het
                    algemeen gekeken wordt. Voor verwaarlozing gelden volgens wetenschappelijk
                    onderzoek in het bijzonder de volgende risicofactoren (Stith et al. 2009):
                </p>
                <ul>
                    <li>slechte kwaliteit van de ouder-kindrelatie (sterkste voorspeller);</li>
                    <li>de mate waarin de ouder de jeugdige ervaart als een probleem of belasting (sterkste
                        voorspeller);
                    </li>
                    <li>geringe reflectie, lage eigen effectiviteit, zelfvertrouwen en -waardering van de ouder</li>
                    <li>psychopathologie bij de ouder(s);</li>
                    <li>(L)VB: (licht) verstandelijke beperking bij de ouder(s);</li>
                    <li>de mate van boosheid, agressie en hyperreactiviteit bij de ouders;</li>
                    <li>ouderlijke stress;</li>
                    <li>gebrek aan sociale vaardigheden van de jeugdige;</li>
                    <li>werkloosheid ouder(s);</li>
                    <li>gezinsgrootte (hoe groter het gezin hoe meer risico).</li>
                </ul>

                <h5>Specifieke risicofactoren voor seksueel misbruik</h5>
                <p className={'text'}>
                    De risicofactoren die de kans op seksueel misbruik het sterkst verhogen, bevinden
                    zich binnen het microsysteem (in de omgeving dichtbij de jeugdige). Echter, ook
                    factoren die buiten het kind liggen (omgeving verder van de jeugdige af) blijken een
                    belangrijke invloed te kunnen hebben op slachtofferschap van seksueel
                    kindermisbruik. Factoren met betrekking tot de ouder-kindrelatie en de houding van
                    ouders ten opzichte van de jeugdige blijken, in tegenstelling tot wat verwacht zou
                    worden, van kleine tot zeer kleine invloed te zijn. Specifiek voor slachtofferschap van
                    seksueel misbruik zijn de volgende risicofactoren (Berger, 2004; De Jong &amp;
                    Meeuwsen, 2014; Nationaal Rapporteur Mensenhandel en seksueel geweld tegen
                    kinderen, 2014).
                </p>
                <p className={'text'}>Microsysteem:</p>
                <ul>
                    <li>een (verstandelijke) beperking, chronische ziekte of ontwikkelingsachterstand bij de jeugdige;
                    </li>
                    <li>geslacht (meisje);</li>
                    <li>eerder slachtofferschap van seksueel geweld;</li>
                    <li>delinquentie van de jeugdige;</li>
                    <li>fysieke of emotionele afwezigheid van de moeder (bijvoorbeeld bij verslaving of psychiatrie en
                        (L)VB);
                    </li>
                    <li>het ontbreken van een ondersteunende relatie tussen ouder en jeugdige en een tekort aan
                        opvoedingsvaardigheden bij de niet-plegende ouder;
                    </li>
                    <li>huiselijk geweld in het gezin, verstoorde interactiepatronen, verstoorde gezinsrelaties;</li>
                    <li>gezinssamenstelling: aanwezigheid van een stiefvader.</li>
                    <li>Omgeving verder weg van het kind (mesosysteem):</li>
                    <li>wonen in een stedelijk gebied;</li>
                    <li>wonen in een omgeving met veel (vormen van) geweld.</li>
                </ul>

                <h2>Beschermende factoren voor kindermishandeling</h2>
                <p className={'text'}>
                    Beschermende factoren kunnen tegenwicht bieden aan risico’s waaraan jeugdigen
                    worden blootgesteld. De aanwezigheid van beschermende factoren kan de negatieve
                    werking van risicofactoren beperken maar niet per definitie compenseren.
                </p>
                <p className={'text'}>
                    Beschermende factoren zijn relevant voor het schatten van de grootte van een risico
                    op kindermishandeling, voor de impact van kindermishandeling op jeugdigen en voor
                    het succes van (preventieve) interventies bij kindermishandeling.
                </p>
                <p>
                    Bij deze factoren kan onderscheid gemaakt worden tussen:
                </p>

                <ul>
                    <li>beschermende factoren: dit zijn factoren die een directe gunstige invloed op risicofactoren of
                        de
                        situatie hebben, zodat de kindermishandeling afneemt of stopt of de impact van de mishandeling
                        kleiner
                        wordt;
                    </li>
                    <li>(veiligheids)bevorderende factoren, moderators of buffers: dit zijn factoren die het gedrag van
                        ouders
                        of jeugdige zodanig beïnvloeden dat kindermishandeling wordt voorkomen of wordt gestopt,
                        ongeacht de
                        aanwezigheid van risicofactoren. Deze factoren beïnvloeden het verband tussen risicofactoren en
                        het
                        voorkomen van kindermishandeling in gunstige zin (Folger &amp; Wright, 2013;
                        Jenson &amp; Fraser, 2011;
                        Kraemer et al. 1997).
                    </li>
                </ul>

                <p className={'text'}>
                    Er is weinig onderzoek gedaan naar beschermende en veiligheidsbevorderende
                    factoren voor kindermishandeling, maar recentelijk is het Protective Factor
                    Framework ontwikkeld (Development Services Group, 2013).
                </p>

                <h3>De belangrijkste beschermende factoren bleken</h3>

                <ul>
                    <li>Intrapersoonlijke factoren (bij de jeugdige zelf) die de impact van kindermishandeling op de
                        jeugdige
                        gunstig kunnen beïnvloeden:
                    </li>
                    <li>gevoel van perspectief, zingeving;</li>
                    <li>eigen effectiviteit beleving (positieve interne ‘locus of control’);</li>
                    <li>vermogen tot zelfregulatie;</li>
                    <li>oplossingsvermogen;</li>
                    <li>sociale vaardigheden;</li>
                    <li>positieve betrokkenheid bij activiteiten;</li>
                    <li>Interpersoonlijke factoren (bij de ouder(s) of andere volwassenen):</li>
                    <li>opvoedvaardigheden, competenties ouder(s);</li>
                    <li>positieve invloedrijke andere volwassenen (niet-professionals uit eigen netwerk);</li>
                    <li>welzijn van de ouder(s);</li>
                </ul>

                <h3>Omgevingsfactoren</h3>

                <ul>
                    <li>positieve schoolomgeving;</li>
                    <li>stabiele woonsituatie.</li>
                </ul>

                <p className={'text'}>
                    Naast de factoren in het Protective Factor Framework worden ook de factoren
                    veerkracht en sociale steun in de literatuur beschreven.
                </p>

                <ul>
                    <li>
                        Veerkracht (resilience) van zowel ouders als jeugdigen komt in veel studies als
                        positieve factor naar voren (Horton, 2013; Langford, Lewis, Solomon, &amp; Warin,
                        2001; Sahlberg, 2012). Kenmerken van veerkrachtige jeugdigen zijn: een
                        gemakkelijk temperament, flexibiliteit, oplossings- en planningsvaardigheden en
                        sociale vaardigheden in combinatie met een ondersteunende sterke gezinsband,
                        aanwezige (beide) ouders, een intact gezin en steun uit de nabije omgeving
                        (zowel van leeftijdsgenoten als van familie en professionals) (Sahlberg, 2012).
                    </li>
                    <li>
                        <p className={'text'}>
                            Sociale steun is volgens meerdere studies ook een beschermende factor. Bij
                            laagopgeleide moeders beschermt een hoog niveau van sociale steun: het risico
                            op kindermishandeling wordt dan tot de helft verminderd (Li, Godinet, &amp;
                            Arnsberger, 2011). Kaufman en Charney (2001) onderzochten waarom sommige
                            jeugdigen ondanks kindermishandeling goed functioneren en zich normaal
                            ontwikkelen. De betrokkenheid van warme, stabiele andere verzorgenden bleek
                            de belangrijkste factor.
                        </p>

                        <p className={'text'}>
                            Er worden in de literatuur vier functies van sociale steun onderscheiden (Van
                            Yperen, 2013) en deze kunnen zowel op ouders als op jeugdigen worden
                            toegepast:
                        </p>

                        <ul>
                            <li>emotionele steun bij vragen, twijfels en problemen van ouders en jeugdigen (bv. buren of
                                ouders
                                van vriendjes/vriendinnetjes);
                            </li>
                            <li>praktische steun (bijvoorbeeld voor oppas of hulp in de huishouding; of kleding via de
                                kerk voor
                                de jeugdigen);
                            </li>
                            <li>informatieve ondersteuning waarbij advies, informatie of feedback gegeven wordt waardoor
                                de
                                kennis en vaardigheden van ouders en jeugdigen kunnen toenemen (denk bijvoorbeeld aan de
                                Kindertelefoon voor jeugdigen; websites zoals ‘Feel the Vibe’ of informatie voor ouders
                                vanuit
                                de jeugdgezondheidszorg/opvoedloketten);
                            </li>
                            <li>normatieve ondersteuning door het stellen van gedragsnormen en modellen van gewenst
                                gedrag (denk
                                aan een oma die met haar zoon praat over zijn alcoholgebruik en agressie in het gezin
                                van haar
                                kleinkinderen).
                            </li>
                        </ul>
                    </li>
                </ul>

                <p className={'text-source'}>
                    <strong>Bron</strong>: <a
                    href={'https://www.ncj.nl/richtlijnen/alle- richtlijnen/richtlijn/?richtlijn=12&amp;rlpag=1610'}
                    target={'_blank'}>
                    https://www.ncj.nl/richtlijnen/alle- richtlijnen/richtlijn/?richtlijn=12&amp;rlpag=1610
                </a>
                </p>
            </Panel>
        </div>
    </Modal>
);


export default Ogen;
